<template>
    <div class="areas-expertise">
        <Popup :value="show" :close-on-click-overlay="false" position="bottom">
            <div class="content">
                <div class="title">选择擅长领域</div>
<!--                <div class="tip">最多选择三项</div>-->
                <div class="list">
                    <Collapse v-model="activeNames">
                        <CollapseItem :title="item.name" :name="item.code" :border="false" v-for="item in option"
                                      :key="item.code">
                            <div class="tag" @click="clickTag(tag.code)"
                                 :class="value.indexOf(tag.code) != -1 ? 'active':''" v-for="tag in item.children"
                                 :key="tag.code">{{ tag.name }}
                            </div>
                        </CollapseItem>
                    </Collapse>
                </div>
                <div class="group-btn">
                    <div class="btn no" @click="$emit('cancel')">取消</div>
                    <div class="btn ok" @click="success">完成</div>
                </div>
            </div>
        </Popup>
    </div>
</template>

<script>
    import {Popup, Toast} from 'vant';
    import {Collapse, CollapseItem} from 'vant';
    import {setKeyMap} from '@/utils/setKeyMap.js'

    export default {
        name: 'AreasExpertise',
        props: {
            show: Boolean,
            value: Array
        },
        data: function () {
            return {
                activeNames: [],//展开的面板
                option: []
            }
        },
        methods: {
            success() {
                let retArr = []
                this.option.forEach(r => {
                    r.children.forEach(t => {
                        if (this.value.indexOf(t.code) != -1) {
                            retArr.push(t)
                        }
                    })
                })
                this.$emit('confirm', retArr)
            },
            clickTag(code) {
                let index = this.value.indexOf(code);
                if (index != -1) {
                    let newTag = [];
                    this.value.forEach((r, i) => {
                        if (index != i) {
                            newTag.push(r);
                        }
                    });
                    this.$emit('input', newTag)
                } else {
                    // if (this.value.length >= 3) {
                    //     Toast('最多选择三项！');
                    //     return
                    // }
                    this.$emit('input', [...this.value, code])
                }
            }
        },
        created() {
            setKeyMap({}, ['D_workstation_field']).then(r => {
                this.option = r.D_workstation_field;
                this.option.forEach(r => {
                    r.children.forEach(t => {
                        if (this.value.indexOf(t.code) != -1) {
                            this.activeNames.push(r.code)
                        }
                    })
                })
            }).catch(_ => {
            })


        },
        components: {Popup, Collapse, CollapseItem}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .areas-expertise {
        .content {
            display: flex;
            flex-direction: column;
            min-height: 88vh;
            max-height: 100vh;
            overflow: auto;

            .van-cell__title {
                color: #666;
                font-size: 14px;
            }

            .van-cell__right-icon {
                color: #E3E5E9;
                font-weight: bold;
            }

            .title {
                width: 100%;
                height: 45px;
                text-align: center;
                line-height: 45px;
                color: #222;
                font-size: 15px;
            }

            .tip {
                padding: 0 18px;
                color: #F84025;
                background: #FCE9E6;
                width: 100%;
                height: 25px;
                font-size: 12px;
                line-height: 25px;
            }

            .van-collapse-item__content {
                padding: 0 15px;
            }

            .list {
                flex: 1;
                margin-bottom: 80px;
                overflow-y: auto;
            }

            .tag {
                display: inline-block;
                margin-right: 8px;
                margin-bottom: 8px;
                font-size: 14px;
                overflow: hidden;
                color: #222;
                padding: 10px 12px;
                background: #F3F5F9;
                border-radius: 2px;

                &.active {
                    background: #FEEDEA;
                    position: relative;

                    &::before {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        right: 0;
                        width: 16px;
                        height: 16px;
                        background-image: url("./yse.png");
                        background-size: 100% 100%;
                        background-repeat: no-repeat;
                    }
                }
            }

            .group-btn {
                width: 100%;
                height: 80px;
                padding: 15px;
                display: flex;
                bottom: 0;
                background: #fff;
                position: fixed;
                left: 0;
                justify-content: space-between;
                align-items: center;

                .btn {
                    width: 168px;
                    height: 40px;
                    text-align: center;
                    line-height: 40px;
                    font-size: 15px;
                }

                .no {
                    color: #373D52;
                    background: #F3F5F9;
                }

                .ok {
                    color: #222222;
                    background: #FFDB06;
                }
            }
        }
    }

</style>
